// Sổ cờ trạng thái + sổ `claimed` (core.ledger, từ save v2). Cờ lạ vẫn được giữ nguyên.
import { signal, computed } from '@preact/signals';
import { registerSlice } from '../registry';
import { emptyLedger, isPlainObject, type SaveLedger } from '@save/types';
import type { FlagValue } from '@data/flags';

const _ledger = signal<SaveLedger>(emptyLedger());
export const ledger = computed(() => _ledger.value);

registerSlice<SaveLedger>({
  key: 'ledger',
  scope: 'core',
  serialize: () => _ledger.value,
  hydrate: (d) => {
    if (!isPlainObject(d)) return void (_ledger.value = emptyLedger());
    const flags = isPlainObject(d.flags) ? (d.flags as SaveLedger['flags']) : {};
    const claimed = Array.isArray(d.claimed)
      ? d.claimed.filter((x): x is string => typeof x === 'string')
      : [];
    _ledger.value = { flags: { ...flags }, claimed };
  },
});

/** Đặt một cờ trạng thái (Bất biến 8: cờ nằm trong save). */
export function setFlag(id: string, v: FlagValue): void {
  if (_ledger.value.flags[id] === v) return;
  _ledger.value = { ..._ledger.value, flags: { ..._ledger.value.flags, [id]: v } };
}

export function isClaimed(key: string): boolean {
  return _ledger.value.claimed.includes(key);
}

/** Chỉ grantReward và các sự kiện "một lần" được gọi. */
export function markClaimed(key: string): void {
  if (isClaimed(key)) return;
  _ledger.value = { ..._ledger.value, claimed: [..._ledger.value.claimed, key] };
}
